import { render } from "./outboundCallRecords.vue?vue&type=template&id=2d75e500&scoped=true"
import script from "./outboundCallRecords.vue?vue&type=script&lang=js"
export * from "./outboundCallRecords.vue?vue&type=script&lang=js"

import "./outboundCallRecords.vue?vue&type=style&index=0&id=2d75e500&scoped=true&lang=css"
import "./outboundCallRecords.vue?vue&type=style&index=1&id=2d75e500&lang=css"
script.render = render
script.__scopeId = "data-v-2d75e500"

export default script